/**
 * Nhận diện sàn từ link user dán — dùng cho "dán nhầm sàn tự chuyển trang".
 *
 * Bám sát bản mobile `mobile/src/core/utils/platform-url-detector.ts` (cùng bộ domain,
 * cùng thứ tự xét) để web và app không xử sự khác nhau trên cùng một link.
 *
 * Khác `pages/LinkConverter` (bộ nhận diện riêng của trang Rải link, chỉ 3 sàn và phục
 * vụ hiển thị badge): file này phủ đủ 4 sàn có trang Mua sắm hoàn tiền và trả kèm
 * đường dẫn trang để điều hướng.
 */

/** Thứ tự QUAN TRỌNG: ShopeeFood xét trước Shopee vì link đồ ăn cũng nằm trên shopee.vn */
const PLATFORM_PATTERNS = [
    {
        pattern: /https?:\/\/([\w-]+\.)?(shopeefood\.vn|shopeefood\.shopee\.vn|spf\.shopee\.vn)\S*|https?:\/\/([\w-]+\.)?(shopee\.vn|shp\.ee|shope\.ee)\/\S*(now-food|shopeefood)\S*/i,
        platform: "shopeefood",
        path: "/shopeefood",
    },
    {
        pattern: /https?:\/\/([\w-]+\.)?(shopee\.vn|shp\.ee|shope\.ee|shopee\.co)\S*/i,
        platform: "shopee",
        path: "/shopee",
    },
    {
        pattern: /https?:\/\/([\w-]+\.)?(lazada\.vn|lazada\.com|lzd\.co)\S*/i,
        platform: "lazada",
        path: "/lazada",
    },
    {
        pattern: /https?:\/\/([\w-]+\.)?(tiktok\.com|vt\.tiktok\.com)\S*/i,
        platform: "tiktok",
        path: "/tiktok",
    },
];

/**
 * @param {string} text link hoặc đoạn text có chứa link (share text hay kèm mô tả)
 * @returns {{platform: string, path: string, url: string}|null} null = không nhận ra sàn nào
 */
export function detectPlatformFromUrl(text) {
    if (!text || !String(text).trim()) return null;

    // Lấy URL đầu tiên trong text; không có thì coi cả chuỗi là link
    const urlMatch = String(text).match(/https?:\/\/\S+/i);
    const url = urlMatch ? urlMatch[0] : String(text).trim();

    for (const { pattern, platform, path } of PLATFORM_PATTERNS) {
        if (pattern.test(url)) return { platform, path, url };
    }
    return null;
}

export default detectPlatformFromUrl;
